const STORAGE_KEYS = {
  likes: "sceneit_likes",
  wishlist: "sceneit_wishlist",
  watchlist: "sceneit_watchlist",
};

export function loadFromStorage(key) {
  try {
    const data = localStorage.getItem(STORAGE_KEYS[key]);
    return data ? JSON.parse(data) : {};
  } catch (err) {
    console.warn(`Failed to load ${key} from storage:`, err);
    return {};
  }
}

export function saveToStorage(key, data) {
  try {
    localStorage.setItem(STORAGE_KEYS[key], JSON.stringify(data));
  } catch (err) {
    console.warn(`Failed to save ${key} to storage:`, err);
  }
}
